// src/theme.ts
import { extendTheme } from '@chakra-ui/react'

const pretendard = `'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif`

const theme = extendTheme({
  fonts: {
    heading: pretendard,
    body: pretendard,
    mono: pretendard
  },
  styles: {
    global: {
      'html, body': {
        fontFamily: pretendard,
        fontWeight: '600',
        wordBreak: 'keep-all'
      },
      '*': {
        fontFamily: pretendard,
        fontWeight: '600',
        wordBreak: 'keep-all'
      }
    }
  },
  colors: {
    orange: {
      50: '#FFF8E1', // 매우 밝은 옐로우 (배경용)
      100: '#FFECB3', // 밝은 파스텔 옐로우
      200: '#FFE082', // 연한 골드 느낌
      300: '#FFD54F', // 부드러운 중간 골드
      400: '#FFCA28', // 좀 더 강한 골드
      500: '#F6C019', // 기준 색상 (중심 골드)
      600: '#FFCA28', // 살짝 어두운 골드
      700: '#B38712', // 채도를 낮춘 중간톤 골드
      800: '#926E0D', // 어두운 머스터드 느낌
      900: '#715609' // 가장 어두운 황금 브라운
    }
  }
})

export default theme
